/* eslint-disable @typescript-eslint/no-explicit-any */
import { Injectable } from '@angular/core';
import { config as conf } from 'src/app/config';

@Injectable({
    providedIn: 'root'
})
export class ChatbotService {
    /**
   * Returns an reaction based on the input from the user
   * @param user_input
   * @returns
   */
    public react(user_input: string) {
        let reaction: string;

        if (this.compare(conf.UTTERANCES, conf.ANSWERS, this.inputPreprocessing(user_input))) reaction = this.compare(conf.UTTERANCES, conf.ANSWERS, this.inputPreprocessing(user_input));
        else reaction = conf.ALTERNATIVES[Math.floor(Math.random() * conf.ALTERNATIVES.length)];

        return reaction;
    }

    /**
   * Preprocesses the input from the user to specified regex
   *
   * @param input
   * @returns
   */
    private inputPreprocessing(input: string) {
        let text = input.toLowerCase().replace(/[^\w\s\d]/gi, '');

        text = text
            .replace(/ a /g, ' ')
            .replace(/whats/g, 'what is')
            .replace(/please /g, '')
            .replace(/ please/g, '')
            .replace(/\s/g, '')// spaces
            .replace(/[-!$%^&*()_+|~=`{}[\]:";'<>?,./]/, '');// symbols

        return text;
    }

    /**
   * Compars the specified user input to the possibilities where it
   * can match to. Than it returns a random value from an array with answers
   * @param utterancesArray
   * @param answersArray
   * @param string
   * @returns
   */
    private compare(utterancesArray: any, answersArray: any, string: string) {
        let item: any;

        for (let x = 0; x < utterancesArray.length; x++) {
            for (let y = 0; y < utterancesArray[x].length; y++) {
                // check and removes all spaces and symbols
                const compareString = utterancesArray[x][y]
                    .replace(/\s/g, '')
                    .replace(/[-!$%^&*()_+|~=`{}[\]:";'<>?,./]/, '');

                if (compareString === string) {
                    const items = answersArray[x];
                    item = items[Math.floor(Math.random() * items.length)];
                }
            }

            item = utterancesArray[x].find(row => {
                if (string.includes(row)) {
                    const items = answersArray[x];
                    return items[Math.floor(Math.random() * items.length)];
                }
                return undefined;
            });
        }

        return item;
    }
}
